// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c20ff4982e9a516ffde057b6f95c9af3b87074f8/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};